import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Space, Tooltip } from 'antd';
import FeatherIcon from 'feather-icons-react';
import { FirstName, FormItem } from './styles/styles';
import { ModalEditFinalCustomers } from '../ModalCreateFinalCustomers';
import { SelectFinalCustomer } from '../SelectFinalCustomer';
import ContainerCountServices from '../ContainerCountServices';
import { Button } from '../../buttons/buttons';
import { useDictionaryTranslation } from '../../../hooks/useDictionaryTranslation';
import { useCanEditFinalCustomer } from '../../../hooks/useCanEditFinalCustomer';
import { ModalFinalCustomerAssigned } from '../../../views/Calendar/components/ModalFinalCustomerAssigned';

export const FinalCustomerInput = ({
  name,
  value: selectedFinalCustomer,
  onChange,
  required = true,
  enableDropdown = true,
  showServicesCount = false,
  disabledEdit = false,
  showEdit = true,
  label = '',
}) => {
  const { translate: t } = useDictionaryTranslation();
  const canEditFinalCustomer = useCanEditFinalCustomer();
  const [modalData, setModalData] = useState({
    show: false,
    selectedCustomerId: null,
  });

  const validateValue = async () => {
    if (required && !selectedFinalCustomer) throw new Error('Must select a final customer');
    return true;
  };

  const createFinalCustomer = () => {
    setModalData({ show: true, selectedCustomerId: null });
  };

  const editFinalCustomer = () => {
    setModalData({ show: true, selectedCustomerId: selectedFinalCustomer?._id });
  };

  const updateModalData = ({ show = false, selectedCustomerId = null } = {}) => {
    setModalData({
      show,
      selectedCustomerId,
    });
  };

  const closeModal = (_, customerData) => {
    if (customerData) onChange(customerData);
    updateModalData();
  };

  return (
    <>
      <FormItem
        name={name}
        label={t(label)}
        rules={[{ validator: validateValue, required, message: t('finalCustomerRequired') }]}
      >
        {enableDropdown ? (
          <Row justify="end" gutter={8} wrap={false}>
            <Col flex="auto" style={{ minWidth: 0 }}>
              <SelectFinalCustomer onChange={onChange} selectedFinalCustomer={selectedFinalCustomer} />
            </Col>
            <Col flex="none">
              <Space size="small">
                {canEditFinalCustomer ? (
                  <Tooltip title={t('createFinalCustomer')}>
                    <Button type="secondary" size="large" onClick={createFinalCustomer}>
                      <FeatherIcon icon="plus" />
                    </Button>
                  </Tooltip>
                ) : null}
                {showEdit && canEditFinalCustomer ? (
                  <Tooltip title={t('editFinalCustomer')}>
                    <Button
                      type="secondary"
                      size="large"
                      onClick={editFinalCustomer}
                      disabled={disabledEdit || !selectedFinalCustomer}
                    >
                      <FeatherIcon icon="edit" />
                    </Button>
                  </Tooltip>
                ) : null}
              </Space>
            </Col>
          </Row>
        ) : (
          <>
            <Row justify="end" gutter={20}>
              <Col xs={24}>
                <Button type="secondary" onClick={editFinalCustomer}>
                  <Space>
                    <FeatherIcon icon="search" style={{ marginTop: '6px' }} />
                    {t('assignFinalCustomer')}
                  </Space>
                </Button>
              </Col>
              <Col md={24}>
                <Row>
                  <FirstName>{selectedFinalCustomer?.firstName}</FirstName>
                </Row>
              </Col>
            </Row>
          </>
        )}
        {selectedFinalCustomer && showServicesCount ? (
          <ContainerCountServices selectedFinalCustomer={selectedFinalCustomer} />
        ) : null}
      </FormItem>
      <ModalEditFinalCustomers />

      <ModalFinalCustomerAssigned
        finalCustomerId={modalData.selectedCustomerId}
        handleClose={closeModal}
        show={modalData.show}
      />
    </>
  );
};

FinalCustomerInput.propTypes = {
  name: PropTypes.string,
  value: PropTypes.object,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  enableDropdown: PropTypes.bool,
  showServicesCount: PropTypes.bool,
  label: PropTypes.string,
  disabledEdit: PropTypes.bool,
  showEdit: PropTypes.bool,
};
